function getPanoUrl({ cdnDomain, path }: { cdnDomain: number; path: string }) {
  return `https://ssl-panoimg${cdnDomain}.720static.com${path}`;
}

export default getPanoUrl;
